import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Downloading Ditto", -1)
const _hoisted_2 = { class: "dt-instructions__instructions-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("article", {
  key: "1",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/download@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "1. Download"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, [
        /*#__PURE__*/_createTextVNode("Download Ditto Connect on your Chromebook device "),
        /*#__PURE__*/_createElementVNode("a", {
          target: "_blank",
          rel: "noreferrer noopener",
          href: "https://chrome.google.com/webstore/detail/ditto-connect/ikfklloihafebojfcafbcidcmdjnjcpd"
        }, "here"),
        /*#__PURE__*/_createTextVNode(".")
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("article", {
  key: "2",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/ditto@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "2. Open"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Press Launcher at the lower left corner of the screen and press the up arrow to expand your apps. Locate Ditto and open it.")
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("article", {
  key: "3",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/share@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "3. Share"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, [
        /*#__PURE__*/_createTextVNode("That's it! Press '"),
        /*#__PURE__*/_createElementVNode("strong", null, "Start Sharing"),
        /*#__PURE__*/_createTextVNode("' and your computer screen will appear on the big screen.")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, {
        appear: "",
        name: "fade-up"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ], 64))
}